export default __webpack_public_path__ + "static/media/electronics-banner-1.4705dd75.jpg";